module.exports = __webpack_public_path__ + "img/boton comprobar.dcbdc33c.svg";